import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "alipay-result" }
const _hoisted_2 = { class: "result-header" }
const _hoisted_3 = { class: "result-title" }
const _hoisted_4 = { class: "result-info" }
const _hoisted_5 = { class: "amount" }
const _hoisted_6 = { class: "order-no" }
const _hoisted_7 = {
  key: 1,
  class: "error-message"
}
const _hoisted_8 = { class: "action-buttons" }
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"} }

import { ref, onMounted, computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { showToast } from 'vant';
  import h5Config from '@/config/config';
  import { startPayment } from '@/service/payment';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AlipayResultView',
  setup(__props) {

_useCssVars(_ctx => ({
  "312bc2ed": (_unref(h5Config).themeColor)
}))

  const route = useRoute();
  const router = useRouter();

  // 状态变量
  const isSuccess = ref(true);
  const amount = ref('0.00');
  const orderNumber = ref('');
  const errorMessage = ref('支付未完成，请重试');
  const payUrl = ref('');
  const displayIosPaymentDialog = ref(false);

  // 设备检测
  const isIOS = computed(() => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  });

  const isWeChatBrowser = computed(() => {
    return /MicroMessenger/i.test(navigator.userAgent);
  });

  onMounted(() => {
    // 从URL获取支付结果参数
    const { status, totalAmount, orderNo } = route.query;

    // 设置支付结果
    isSuccess.value = status === 'TRADE_SUCCESS';

    // 设置订单信息
    if (totalAmount) amount.value = (totalAmount / 100) as string;
    if (orderNo) orderNumber.value = orderNo as string;

    // 设置错误信息
    if (!isSuccess.value) {
      errorMessage.value = (route.query.message as string) || '支付未完成，请重试';
    }
  });

  // 跳转到订单详情
  const goToOrderDetail = () => {
    const orderId = route.query.orderId;
    if (orderId) {
      router.push(`/order/${orderId}`);
    } else {
      router.push('/order');
    }
  };

  const confirmPaid = () => {
    goToOrderDetail();
  };

  // 返回首页
  const goToHome = () => {
    router.push('/');
  };

  // 重新支付
  const continuePay = () => {
    const orderId = route.query.orderId;
    const paymentMethod = route.query.paymentMethod;
    const amount = route.query.totalAmount / 100;
    const orderNo = route.query.orderNo;
    if (orderId) {
      handleStartPayment(orderId, paymentMethod, amount, orderNo);
    } else {
      showToast('订单信息不存在');
    }
  };

  const handleStartPayment = async (orderId, paymentMethod, amount, orderNo) => {
    try {
      const response = await startPayment({
        orderId: orderId,
        paymentMethod: paymentMethod,
        amount: amount,
        openId: 'openId',
        returnUrl:
          window.location.origin +
          '/payment/alipay/result?orderId=' +
          orderId +
          '&orderNo=' +
          orderNo +
          '&paymentMethod=2',
      });
      if (response.code === 200) {
        const paymentUrl = response.result.request;
        const paymentNo = response.result.paymentNo;
        console.log(paymentUrl);
        payUrl.value = paymentUrl;
        if (payUrl.value) {
          // 根据不同设备采用不同支付策略
          if (isIOS.value) {
            displayIosPaymentDialog.value = true;
          } else {
            startNormalPayment(payUrl.value);
          }
        }
      }
    } catch (error) {
      handlePaymentError('支付请求失败，请重试');
    }
  };

  const confirmPay = () => {
    startIOSPayment(payUrl.value);
  };

  // iOS设备支付策略
  const startIOSPayment = (payUrl) => {
    try {
      window.location.href = payUrl;
    } catch (error) {
      console.error('iOS支付启动失败:', error);
      handlePaymentError('支付启动失败，请重试');
    }
  };

  // 普通设备支付策略
  const startNormalPayment = (payUrl) => {
    window.location.href = payUrl;
  };

  const handlePaymentError = (message) => {
    errorMessage.value = message;
  };

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          class: "fas fa-chevron-left back-icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header-title" }, "支付结果", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "header-placeholder" }, null, -1))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["result-icon", { success: isSuccess.value, fail: !isSuccess.value }])
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(isSuccess.value ? 'fas fa-check-circle' : 'fas fa-clock')
        }, null, 2)
      ], 2),
      _createElementVNode("div", _hoisted_3, _toDisplayString(isSuccess.value ? '支付成功' : '等待支付'), 1),
      _createElementVNode("div", _hoisted_4, [
        (isSuccess.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_5, "¥" + _toDisplayString(amount.value), 1),
              _createElementVNode("div", _hoisted_6, "订单号：" + _toDisplayString(orderNumber.value), 1)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, "请尽快完成支付，订单将在15分钟后关闭"))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (isSuccess.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "primary-button",
                onClick: goToOrderDetail
              }, "查看订单"),
              _createElementVNode("button", {
                class: "secondary-button",
                onClick: goToHome
              }, "返回首页")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("button", {
                class: "primary-button",
                onClick: continuePay
              }, "继续支付"),
              _createElementVNode("button", {
                class: "secondary-button",
                onClick: confirmPaid
              }, "已完成支付")
            ], 64))
      ])
    ]),
    _createVNode(_component_van_dialog, {
      title: " ",
      show: displayIosPaymentDialog.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((displayIosPaymentDialog).value = $event)),
      onConfirm: confirmPay,
      "show-cancel-button": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_van_image, {
            width: "100",
            fit: "contain",
            src: "https://gw.alipayobjects.com/mdn/rms_7e962d/afts/img/A*yCL8TrkjIx8AAAAAAAAAAAAAARQnAQ",
            class: "restaurant-image",
            style: {"text-align":"center"}
          }),
          _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"text-align":"center","line-height":"24px","color":"blue","padding":"15px"} }, "是否跳转至支付宝页面", -1))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})